export enum RechnungStatus {
  OFFEN = 'OFFEN',
  MAHNUNG_1 = 'MAHNUNG_1',
  MAHNUNG_2 = 'MAHNUNG_2',
  BEZAHLT = 'BEZAHLT',
  TEILBEZAHLT = 'TEILBEZAHLT',
  REKLAMIERT = 'REKLAMIERT',
  STORNIERT = 'STORNIERT',
  GUTSCHRIFT = 'GUTSCHRIFT',
  UEBERFAELLIG = 'UEBERFAELLIG',
}
